import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import { AuthenticateComponent } from './authenticate/authenticate.component';
import {MatInputModule, MatButtonModule, MatSelectModule, MatProgressSpinnerModule} from "@angular/material";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {PricingComponent} from "./pricing/pricing.component";
import {AppRoutingModule} from "../app-routing.module";
import {CheckitDashboardModule} from "./checkit-dashboard/checkit-dashboard.module";
import {AccountComponent} from "./account/account.component";
import {PaymentFormComponent} from "../payment/payment-form/payment-form.component";
import {UserSubscriptionsComponent} from "../payment/user-subscriptions/user-subscriptions.component";
import {PaymentModule} from "../payment/payment.module";
import {StripePipe} from "../shared/stripe.pipe";
import {SharedModule} from "../shared/shared.module";
import { RsvpComponent } from './rsvp/rsvp.component';
import {AccountModule} from "./account/account.module";
import { CheckinComponent } from './checkin/checkin.component';

/**
 * Created by greg on 27/02/2018.
 */

@NgModule({
    imports: [
        CommonModule,
        AppRoutingModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        FormsModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        CheckitDashboardModule,
        AccountModule,
        PaymentModule,
        SharedModule
    ],
    declarations: [
        AuthenticateComponent,
        PricingComponent,
        RsvpComponent,
        CheckinComponent
    ]
})
export class PagesModule { }


// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts